
import "/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/components/HeaderSearch/index.less?modules";
export default {"input": `input-MSxpi_7g`,"show": `show-rAuK-fqU`,"headerSearch": `headerSearch-LmYGNCpp`}
